import { useContext } from 'react';
import clsx from 'clsx';

import { FormParserContext } from 'src/contexts/form.context';
import { P6 } from 'src/components/Typography/Paragraph';

import classes from './BottomLabel.module.scss';

export function BottomLabel() {
  const { script, error } = useContext(FormParserContext);

  if (!script.bottomLabel && !error) return <></>;

  return <P6 className={clsx(classes.label, { [classes.error]: !!error })}>{error ?? script.bottomLabel}</P6>;
}
